import { mapRasse } from '@ps20-frontend/migrations';
import { ThhHundAngabenElement } from '../reducer/thhHundAngaben.reducer';
import { TkvAngabenElement } from '../reducer/tkvAngaben.reducer';
import { StatePreV21, StateV21 } from './21_migrate_rasse.interface';

export const migrateRassen = (previousState: StatePreV21, newVersion: number): StateV21 => {
  return {
    ...previousState,
    version: newVersion,
    thhHundAngaben: {
      ...previousState.thhHundAngaben,
      angabenListe: mapThhHundAngaben(previousState.thhHundAngaben.angabenListe),
    },
    tkvAngaben: {
      ...previousState.tkvAngaben,
      angabenListe: mapTkvAngaben(previousState.tkvAngaben.angabenListe),
    },
  };
};

function mapThhHundAngaben(thhHundAngaben: ThhHundAngabenElement[]): ThhHundAngabenElement[] {
  return thhHundAngaben?.map(angabe => {
    return { ...angabe, hunderasseValue: mapRasse(angabe.hunderasseValue) };
  });
}

function mapTkvAngaben(tkvAngaben: TkvAngabenElement[]): TkvAngabenElement[] {
  return tkvAngaben?.map(angabe => {
    return { ...angabe, rasse: { ...angabe.rasse, value: mapRasse(angabe.rasse.value) } };
  });
}
